import { createBrowserRouter } from "react-router-dom";
import Root from "../views/Root";
import NotFound from "../views/NotFound";
import ScrollHandler from "../components/ScrollHandler";

const AppRoutes = createBrowserRouter([
  {
    path: "/p/:packageId/",
    element: (
      <ScrollHandler>
        <Root />
      </ScrollHandler>
    ),
  },
  {
    path: "/cs/:packageId/",
    element: (
      <ScrollHandler>
        <Root />
      </ScrollHandler>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default AppRoutes;
